import React, { useEffect, useState } from "react";
// UI Libraries
import { Card, Col, Container, Row, Table } from "reactstrap";
// Components
import BreadCrumb from "Components/Basic/BreadCrumb";
// Helpers and Hooks
import { isMalaysiaCompany } from "helpers/Others/company_helper";
import { useGlobalHooks } from "hooks/useGlobalHooks";
import { getAppConfig } from "config/configInitializer";

interface ContactInfo {
  language: string;
  accessibility: string;
  phone: string;
  email: string;
}

const ContactUs: React.FC = () => {
  const { t } = useGlobalHooks();
  const [isMalaysia, setIsMalaysia] = useState(false);

  useEffect(() => {
    (async () => {
      const malaysia = await isMalaysiaCompany();
      setIsMalaysia(malaysia);
    })();
  }, []);

  const config = getAppConfig();
  const { company } = config;

  const CONTACT_DATA: ContactInfo[] = [
    {
      language: "english",
      accessibility: "24/7",
      phone: "+44 1460944002",
      email: company.SUPPORT_EMAIL,
    },
    {
      language: "chinese",
      accessibility: "24/7",
      phone: "+86 400 842 7771",
      email: company.SUPPORT_EMAIL,
    },
    {
      language: "hindi",
      accessibility: "24/7",
      phone: "+91 1800 270 4273",
      email: company.SUPPORT_EMAIL,
    },
    {
      language: "korean",
      accessibility: "24/7",
      phone: "+82 7047318492",
      email: company.SUPPORT_EMAIL,
    },
  ];

  const MALAYSIA_SPECIFIC_CONTACT: ContactInfo = {
    language: "thai",
    accessibility: "24/7",
    phone: "+441460944002",
    email: company.SUPPORT_EMAIL,
  };

  const MapFrame = () => (
    <iframe
      src={
        isMalaysia
          ? "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8150000.5817306675!2d104.32542026719952!3d4.123041060666138!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3034d3975f6730af%3A0x745969328211cd8!2sMalezya!5e0!3m2!1str!2str!4v1709897612299!5m2!1str!2str"
          : "https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d30282.456024877887!2d-64.63645241604178!3d18.42436490578398!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sSea%20Meadow%20House%2C%20P.O.%20Box%20116%2C%20Road%20Town%20Tortola%2C%20BVI!5e0!3m2!1str!2sie!4v1716278461540!5m2!1str!2sie"
      }
      width="100%"
      height="450"
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  );

  const ContactRow: React.FC<ContactInfo> = ({
    language,
    accessibility,
    phone,
    email,
  }) => (
    <tr>
      <td>{t(language)}</td>
      <td>{accessibility}</td>
      <td>
        <a href={`tel:${phone.replace(/\s/g, "")}`} className="text-dark">
          {phone}
        </a>
      </td>
      <td>
        <a href={`mailto:${email}`} className="text-dark">
          {email}
        </a>
      </td>
    </tr>
  );

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title={t("contactus")}
          pageTitle={t("accounts")}
          currentPage={t("contactus")}
        />

        <Row>
          <Col xs={12}>
            <Card className="base-card">
              <Table striped responsive>
                <thead>
                  <tr>
                    <th>{t("language")}</th>
                    <th>{t("accessibility")}</th>
                    <th>{t("phone")}</th>
                    <th>{t("emailwithoutdash")}</th>
                  </tr>
                </thead>
                <tbody>
                  {CONTACT_DATA.map((contact) => (
                    <ContactRow
                      key={`contact-us-${contact.language}`}
                      {...contact}
                    />
                  ))}
                  {isMalaysia && <ContactRow {...MALAYSIA_SPECIFIC_CONTACT} />}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <div className="address text-center mt-4 mb-5">
              {t("addressint2")}
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Card className="base-card">
              <MapFrame />
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ContactUs;
